import {
  Create,
  ListButton,
  number,
  NumberInput,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

const CreateToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Create" />
    <ListButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const CreateActions = () => (
  <TopToolbar sx={{ justifyContent: "flex-start" }}>
    <ListButton />
  </TopToolbar>
);

export const TrafficSourceCreate = () => (
  <Create actions={<CreateActions />} redirect="list">
    <SimpleForm toolbar={<CreateToolbar />}>
      <TextInput
        source="title"
        helperText="example: Facebook"
        validate={required()}
      />
      <NumberInput
        label="max Click ID Length"
        source="maxClickIdLength"
        validate={[number(), required()]}
      />
    </SimpleForm>
  </Create>
);
